let elements = {
  //pick: 3,
  blockCheck: true,
  // permanent: true,
  mainImage: {
    imagePath: 'games/page028_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page028_game0/audio/false.mp3',
    // positive: 'games/page028_game0/audio/true.mp3',
    // click: 'games/page028_game0/audio/click.mp3',
    icon: {
      on: 'games/page028_game0/img/audioOn.png',
      off: 'games/page028_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 48,
    height: 48,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 486,
    height: 474,
  },
  layoutItems: [
    {
      pos: {
        x: 290,
        y: 814,
      },
    },
    {
      pos: {
        x: 833,
        y: 814,
      },
    },
    {
      pos: {
        x: 1391,
        y: 814,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 235,
        y: 247,
      },
    },
    {
      pos: {
        x: 235,
        y: -28,
      },
    },
    {
      pos: {
        x: 827,
        y: 247,
      },
    },
    {
      pos: {
        x: 827,
        y: -28,
      },
    },
    {
      pos: {
        x: 1371,
        y: 247,
      },
    },
    {
      pos: {
        x: 1371,
        y: -28,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page028_game0/audio/36_sing.mp3',
          correct: {
            image: {
              src: 'games/page028_game0/img/sing.webp',
            },
            width: 275,
            height: 275,
            correctItems: {
              images: [
                {
                  src: 'games/page028_game0/img/singok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 275,
                  height: 275,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page028_game0/img/dance.webp',
            },
            width: 275,
            height: 275,
            incorrectItems: {
              images: [
                {
                  src: 'games/page028_game0/img/dancewr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 275,
                  height: 275,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page028_game0/audio/37_catch.mp3',
          correct: {
            image: {
              src: 'games/page028_game0/img/catch.webp',
            },
            width: 275,
            height: 275,
            correctItems: {
              images: [
                {
                  src: 'games/page028_game0/img/catchok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 275,
                  height: 275,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page028_game0/img/jump.webp',
            },
            width: 275,
            height: 275,
            incorrectItems: {
              images: [
                {
                  src: 'games/page028_game0/img/jumpwr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 275,
                  height: 275,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page028_game0/audio/40_run.mp3',
          correct: {
            image: {
              src: 'games/page028_game0/img/run.webp',
            },
            width: 275,
            height: 275,
            correctItems: {
              images: [
                {
                  src: 'games/page028_game0/img/runok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 275,
                  height: 275,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page028_game0/img/paint.webp',
            },
            width: 275,
            height: 275,
            incorrectItems: {
              images: [
                {
                  src: 'games/page028_game0/img/paintwr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 275,
                  height: 275,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  staticMaskConfig: [
    {
      id: 'm1',
      pos: {
        x: 215 + 17,
        y: 283 - 35,
      },
      unit: 'px',
      click: { src: 'games/page028_game0/audio/click.mp3' },
      src: 'games/page028_game0/img/folia.webp',
    },
    {
      id: 'm2',
      pos: {
        x: 215 + 17,
        y: 9 - 35,
      },
      unit: 'px',
      click: { src: 'games/page028_game0/audio/click.mp3' },
      src: 'games/page028_game0/img/folia.webp',
    },
    {
      id: 'm3',
      pos: {
        x: 809 + 17,
        y: 283 - 35,
      },
      unit: 'px',
      click: { src: 'games/page028_game0/audio/click.mp3' },
      src: 'games/page028_game0/img/folia.webp',
    },
    {
      id: 'm4',
      pos: {
        x: 808 + 17,
        y: 9 - 35,
      },
      unit: 'px',
      click: { src: 'games/page028_game0/audio/click.mp3' },
      src: 'games/page028_game0/img/folia.webp',
    },
    {
      id: 'm5',
      pos: {
        x: 1353 + 17,
        y: 283 - 35,
      },
      unit: 'px',
      click: { src: 'games/page028_game0/audio/click.mp3' },
      src: 'games/page028_game0/img/folia.webp',
    },
    {
      id: 'm6',
      pos: {
        x: 1353 + 17,
        y: 9 - 35,
      },
      unit: 'px',
      click: { src: 'games/page028_game0/audio/click.mp3' },
      src: 'games/page028_game0/img/folia.webp',
    },
  ],
  // mbStaticAudioItemData: [
  //   {
  //     src: 'games/page028_game0/audio/36_sing.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       src: { iconOn: 'games/page028_game0/img/audioOn.png', iconOff: 'games/page028_game0/img/audioOff.png' },
  //       fill: 'none',
  //     },
  //     width: '48px',
  //     height: '48px',
  //     pos: {
  //       x: 290,
  //       y: 814,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page028_game0/audio/37_catch.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       src: { iconOn: 'games/page028_game0/img/audioOn.png', iconOff: 'games/page028_game0/img/audioOff.png' },
  //       fill: 'none',
  //     },
  //     width: '48px',
  //     height: '48px',
  //     pos: {
  //       x: 833,
  //       y: 814,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page028_game0/audio/40_run.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       src: { iconOn: 'games/page028_game0/img/audioOn.png', iconOff: 'games/page028_game0/img/audioOff.png' },
  //       fill: 'none',
  //     },
  //     width: '48px',
  //     height: '48px',
  //     pos: {
  //       x: 1391,
  //       y: 814,
  //     },
  //     unit: 'px',
  //   },
  // ],
};

export default elements;
